<div class="notifications-component">
	<button
		mat-icon-button
		class="example-icon favorite-icon"
		[matMenuTriggerFor]="menuNotifications"
		[matBadge]="notifications.length > 0 ? notifications.length : undefined"
	>
		<mat-icon>notifications</mat-icon>
	</button>
	<mat-menu
		class="menu-notifications"
		#menuNotifications
		[xPosition]="!mobileQuery ? 'before' : 'after'"
	>
		<div *ngIf="notifications.length > 0 else noData">
			<app-notification
				*ngFor="let notification of notifications"
				[notification]="notification"
				(closeEvent)="closeNotification($event)"
			></app-notification>
		</div>
		<ng-template #noData>
			<div class='notifications-no-data text-muted'>-- Sin notificaciones --</div>
		</ng-template>
	</mat-menu>
</div>
